module.exports = __webpack_public_path__ + "static/media/background-image.1d058d5a.jpg";